import { render } from "./createRecord.vue?vue&type=template&id=1f5901df&scoped=true"
import script from "./createRecord.vue?vue&type=script&lang=js"
export * from "./createRecord.vue?vue&type=script&lang=js"

import "./createRecord.vue?vue&type=style&index=0&id=1f5901df&scoped=scoped&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5901df"]])

export default __exports__